import { omit } from 'lodash-es';
import qs from 'qs';
import type { ParsedQs } from 'qs';

export type PsfFirstStepRoute = 'combo' | 'socialStarter';

export function getPsfFirstStepRoute(path: string): PsfFirstStepRoute {
	const pathname = path.replace(/[?#].*$/, '');

	const normalizedPathname = pathname.toLowerCase().replace(/\/+$/, '');

	return normalizedPathname.endsWith('/psf/social_starter') ? 'socialStarter' : 'combo';
}

function buildPsfUrl(slug: string, step: string, query: ParsedQs): string {
	return `/p/${encodeURIComponent(slug)}/psf/${step}${qs.stringify(query, { addQueryPrefix: true, arrayFormat: 'repeat' })}`;
}

export function buildSocialStarterUrl(slug: string, query: ParsedQs): string {
	return buildPsfUrl(slug, 'social_starter', omit(query, 'redirect_reason'));
}

export function buildComboUrl(slug: string, query: ParsedQs): string {
	return buildPsfUrl(slug, 'promote_or_share', omit(query, 'redirect_reason'));
}
